export const unstyledButtonSx = {
  border: "none",
  background: "none",
  padding: 0,
  margin: 0,
  fontFamily: "inherit",
  cursor: "pointer",
} as const
